import { GET_USUARIOS, GET_USUARIOS_KD } from '../constants/action_types';

const initialState = { usuarios: [], refresh: false, isLoading: false };

export default function (state = initialState, action) {


    switch (action.type) {
        case GET_USUARIOS:
        
            return { ...state, isLoading: true };

        case GET_USUARIOS_KD:
    
            return { ...state, isLoading: true };
    
        case GET_USUARIOS + "_SUCCESS":
        
            return {
                usuarios: action.payload.data,
                isLoading: false,
                refresh: false
            };

        case GET_USUARIOS_KD + "_SUCCESS":
        
                return {
                    usuarios: action.payload.data,
                    isLoading: false,
                    refresh: false
                };
    
            default:

            return state;
    };
};